import TVdxbDefaultEntry from './index.vue';

TVdxbDefaultEntry.install = app => {
  app.component(TVdxbDefaultEntry.name, TVdxbDefaultEntry);
};

export default TVdxbDefaultEntry;
